export default "__VITE_ASSET__CpyAJ9tY__"